<template lang="pug">
    v-card.mx-lg-auto.mt-md-4.mb-md-4(v-if="validProspectVendor" outlined :width="cardWidth" style="margin: 10px 0px !important;")
        v-toolbar(flat)
            v-btn(
                color="primary"
                icon
                ripple
                @click="showDetails = !showDetails;"
            )
                v-icon(v-if="showDetails === true")
                    | mdi-chevron-down
                v-icon(v-else)
                    | mdi-chevron-right

            v-toolbar-title(style ="font-size: 14px;")
                template(v-if="prospectVendor.vendor_name && prospectVendor.vendor_name.length > 0") {{ prospectVendor.vendor_name }}
                template(v-else) ---
        v-divider
        v-card-text(v-if="showDetails === true")
            v-simple-table
                template(v-slot:default)
                    tbody
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vendor Name 
                                .cell-value-spacing(v-if="prospectVendor.vendor_name && prospectVendor.vendor_name.length > 0") {{ prospectVendor.vendor_name }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Contact Name 
                                .cell-value-spacing(v-if="prospectVendor.vendor_contact_name && prospectVendor.vendor_contact_name.length > 0") {{ prospectVendor.vendor_contact_name }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Contact Email
                                .cell-value-spacing(v-if="prospectVendor.vendor_contact_email && prospectVendor.vendor_contact_email.length > 0") {{ prospectVendor.vendor_contact_email }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Contact Address Street One
                                .cell-value-spacing(v-if="prospectVendor.vendor_contact_address_street_one && prospectVendor.vendor_contact_address_street_one.length > 0") {{ prospectVendor.vendor_contact_address_street_one }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Contact Address Street Two
                                .cell-value-spacing(v-if="prospectVendor.vendor_contact_address_street_two && prospectVendor.vendor_contact_address_street_two.length > 0") {{ prospectVendor.vendor_contact_address_street_two }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Contact Address City
                                .cell-value-spacing(v-if="prospectVendor.vendor_contact_address_city && prospectVendor.vendor_contact_address_city.length > 0") {{ prospectVendor.vendor_contact_address_city }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Contact Address Region
                                .cell-value-spacing(v-if="prospectVendor.vendor_contact_address_region && prospectVendor.vendor_contact_address_region.length > 0") {{ prospectVendor.vendor_contact_address_region }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Contact Address Postal Code
                                .cell-value-spacing(v-if="prospectVendor.vendor_contact_address_postal_code && prospectVendor.vendor_contact_address_postal_code.length > 0") {{ prospectVendor.vendor_contact_address_postal_code }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Contact Phone
                                .cell-value-spacing(v-if="prospectVendor.vendor_contact_phone_number && prospectVendor.vendor_contact_phone_number.length > 0") {{ prospectVendor.vendor_contact_phone_number | tel }}
                                .cell-value-spacing(v-else) N/a

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                cardWidth: 300,
				showDetails: false,
            }
        },
        methods: {
            handleDetailsResize() {
                const detailsWidth = document?.getElementById('prospect-details-card')?.getBoundingClientRect()?.width
                if (detailsWidth >= 375) {
                    this.cardWidth = detailsWidth - 75
                } else {
                    this.cardWidth = 300
                }
            },
        },
        computed: {
            validProspectVendor() {
                return this.prospectVendor?.prospect_vendor_id > 0;
            },
        },
        props: {
            prospectVendor: Object,
        },
        watch: {
            prospectVendor: {
                handler() {
                    Vue.nextTick(() => { this.handleDetailsResize(); });
                },
                deep: true,
            },
        },
        created() {
			window.addEventListener('resize', this.handleDetailsResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleDetailsResize);
        },
        mounted() {
            this.handleDetailsResize();
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .cell-value-spacing {
            padding: 0 0 5px 0;
        }
    }
</style>
